
export default function Pricing() {
  const plans = [
    {
      name: 'Básico',
      subtitle: 'Diseño Gráfico & Branding',
      price: '$150 - $250',
      period: '/mes',
      description: 'Perfecto para emprendedores y pequeños negocios que necesitan identidad visual profesional',
      features: [
        'Diseño de logotipos',
        'Manual de marca',
        'Portadas para redes sociales',
        'Social Media (posts y stories)',
        'Identidad visual completa',
        'Diseño de flyers y banners',
        '3 revisiones incluidas'
      ],
      color: 'from-blue-500 to-cyan-500',
      popular: false
    },
    {
      name: 'Medio',
      subtitle: 'Redes Sociales & Ads',
      price: '$1,200 - $2,500',
      period: '/mes',
      description: 'Ideal para negocios que buscan crecer su presencia en redes sociales y generar leads',
      features: [
        'Todo lo del plan Básico',
        'Gestión de redes sociales',
        'Creación de contenido',
        'Campañas en Meta Ads',
        'Estrategia de contenido',
        'Reportes mensuales',
        'Community management',
        'Optimización de campañas'
      ],
      color: 'from-purple-500 to-pink-500',
      popular: true
    },
    {
      name: 'Premium',
      subtitle: 'Automatización Total',
      price: 'Desde $2,500',
      period: '/mes',
      description: 'Para empresas que quieren escalar con automatización y estrategias avanzadas',
      features: [
        'Todo lo del plan Medio',
        'Automatización de marketing',
        'CRM personalizado',
        'Email marketing automatizado',
        'Chatbots inteligentes',
        'Integración de sistemas',
        'Analítica avanzada',
        'Consultoría estratégica',
        'Soporte prioritario 24/7'
      ],
      color: 'from-orange-500 to-red-500',
      popular: false
    }
  ];

  return (
    <section id="pricing" className="py-24 px-8 md:px-6 relative">
      <div className="container mx-auto max-w-7xl">
        <div className="text-center mb-16 px-4 md:px-0">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">Planes y Precios</h2>
          <p className="text-lg md:text-xl text-gray-400 max-w-2xl mx-auto px-2">
            Elige el plan que mejor se adapte a las necesidades de tu negocio
          </p>
          <p className="text-base md:text-lg text-purple-400 mt-4 px-2">
            *Precios negociables según necesidades específicas
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 items-start">
          {plans.map((plan, index) => (
            <div 
              key={index}
              className={`relative bg-white/5 backdrop-blur-sm rounded-3xl p-8 border transition-all duration-300 hover:transform hover:scale-105 ${
                plan.popular 
                  ? 'border-purple-500 shadow-2xl shadow-purple-500/20 lg:-mt-8' 
                  : 'border-white/10 hover:border-white/20'
              }`}
            >
              {plan.popular && (
                <div className="absolute -top-5 left-1/2 transform -translate-x-1/2">
                  <span className="bg-gradient-to-r from-purple-500 to-pink-500 text-white px-6 py-2 rounded-full text-sm font-bold whitespace-nowrap">
                    Más Popular
                  </span>
                </div>
              )}

              <div className="text-center mb-8">
                <div className={`inline-block px-4 py-2 rounded-full bg-gradient-to-r ${plan.color} text-white text-sm font-semibold mb-4 whitespace-nowrap`}>
                  {plan.subtitle}
                </div>
                <h3 className="text-3xl font-bold text-white mb-2">{plan.name}</h3>
                <div className="flex items-baseline justify-center mb-4">
                  <span className="text-4xl font-bold text-white">{plan.price}</span>
                  <span className="text-gray-400 ml-2">{plan.period}</span>
                </div>
                <p className="text-gray-400 text-sm leading-relaxed">{plan.description}</p>
              </div>

              <ul className="space-y-4 mb-8">
                {plan.features.map((feature, idx) => (
                  <li key={idx} className="flex items-start">
                    <i className="ri-check-line text-green-400 text-xl mr-3 flex-shrink-0 mt-0.5"></i>
                    <span className="text-gray-300">{feature}</span>
                  </li>
                ))}
              </ul>

              <a
                href="#contact"
                className={`block w-full py-4 rounded-xl font-semibold text-center transition-all duration-300 whitespace-nowrap cursor-pointer ${
                  plan.popular
                    ? 'bg-gradient-to-r from-purple-500 to-pink-500 text-white hover:shadow-2xl hover:shadow-purple-500/50'
                    : 'bg-white/10 text-white border border-white/20 hover:bg-white/20'
                }`}
              >
                Contactar
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
